// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    /* Blur */
    --ds-blur-4: var(--ds-1x);
    --ds-blur-12: var(--ds-3x);
    --ds-blur-24: var(--ds-6x);
    --ds-blur-32: var(--ds-8x);
    --ds-blur: var(--ds-blur-12);
    /* Backdrop blur */
    --ds-backdrop-blur: var(--ds-3x);
    --ds-backdrop-blur-focus: var(--ds-8x);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
